import { render, staticRenderFns } from "./transition.vue?vue&type=template&id=1cb8cac9&lang=html&"
import script from "./transition.vue?vue&type=script&lang=ts&"
export * from "./transition.vue?vue&type=script&lang=ts&"
import style0 from "./transition.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports